export default {
  pageTitle: 'Patching Service',
  metaDescription: 'TEF provides on-site patching services for shell and piping leaks, offering fast, cost-effective repairs without disassembly or transportation.',
  sidebar: {
    heading: 'Maintenance And Reconditioning list',
    weldingOverlay: 'Welding Overlay',
    patching: 'Patching',
    piping: 'Piping',
    reshell: 'Re-Shell',
    retubing: 'Re-Tubing',
  },
  title: 'Patching',
  heading: 'On-Site Patching Services for Shell and Piping Leaks',
  paragraph1: 'We provide efficient and reliable patching solutions to address leaks in shells and piping, performed directly at your location. Our portable equipment and experienced technicians ensure quick and effective repairs, minimizing downtime and preventing further damage to your systems.',
  paragraph2: 'Our on-site approach eliminates the need for disassembly or transportation, making it a cost-effective and convenient solution. Whether it’s a temporary fix or a long-term repair, we guarantee high-quality workmanship tailored to your operational needs.',
  steps: {
    step1: 'Remove Outside Insulation',
    step2: 'Outside Shell Patching',
    step3: 'Inside Shell Repairing',
    step4: 'Outside Shell Patching',
    step5: 'Inside Shell Patching',
    step6: 'Outside Nozzle Patching',
    step7: 'Inside Shell',
  },
};
